var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.allTeams,"menu-props":_vm.menuProps,"item-text":"TeamDisplayName","item-value":"TeamID","label":"Team","dense":"","hide-details":"","outlined":""},model:{value:(_vm.team),callback:function ($$v) {_vm.team=$$v},expression:"team"}})
}
var staticRenderFns = []

export { render, staticRenderFns }